import * as React from "react";
import { useState, useMemo } from "react";
import GraphDaysContext from "components/common/Graph/contexts/GraphDaysContext";
import { DAYS } from "components/common/Graph/types";
const GraphDaysContextProvider = ({ children }) => {
  const [graphDays, setGraphDays] = useState(DAYS[0]);
  return /* @__PURE__ */ React.createElement(GraphDaysContext.Provider, { value: useMemo(() => ({ graphDays, setGraphDays }), [graphDays]) }, children);
};
export default GraphDaysContextProvider;
